var map = {
	"./codes/index.js": "ZlVo",
	"./codes2/index.js": "zpxJ",
	"./foots/index.js": "wu3z",
	"./heads/index.js": "p06S",
	"./share/index.js": "Tsk2",
	"./updata/index.js": "1hcj"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "idz+";


//////////////////
// WEBPACK FOOTER
// ./src/components/global \.js$
// module id = idz+
// module chunks = 42